
export default {
  placeInput: {
    findAPlace: 'Find a place',
    place: 'Place',
    addRouteStop: 'Add a route stop',
    routePlace: 'Route stop',
    routeDestination: 'Destination',
    routeDestinationCycleAI: 'Search with CycleAI',
    placeNameRequired: 'Place name required',
    yourLocation: 'Your location',
    couldNotDetermineYourLocation: 'Your location could not be determined. Make sure granted the required permissions',
    useYourLocation: 'Use your current location',
    removeInput: 'Remove place/input',
    directions: 'Directions',
    fromYourBrowser: 'From your device',
    addStartingPlace: 'Add a starting place',
    startingPlace: 'Starting place',
    openInputOptions: 'Open input options',
    addInput: 'Add place input',
    switchCoords: 'Switch coordinates',
    rawCoordinate: 'Lat,lng raw coordinate',
    fillOrRemoveInput: 'Search a place or use the map button on the right',
    noPlaceFound: 'No results returned',
    unknownSearchPlaceError: 'Unknown place search error',
    approximateDistance: 'Approximate distance in a straight line from current map center',
    couldNotDetermineYourPreciseLocationUsingPreviousLocation: 'It was not possible to determine your precise location. Your previous location will be used instead',
    pleaseTypeSomething: 'Please type something to search',
    toggleDirect: 'Toggle direct from here until next place',
    clickOnTheMapToSelectAPlace: 'Pick a place by clicking on a map location',
    clickOnTheMapBtnToPickAPlace: 'Click on this button to pick a place on the map for this input',
    goToDirectionsMode: 'Click the directions button to switch to routing mode',
    clickToSearchAndShowResultsOnTheMap: 'Click to search and show results on the map'
  }
}
